import { ApiService } from "../../../services/api.service";
import { TemplateService } from "../../../services/template.service";
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { GroupedSaleTaxListDetailComponent } from '../grouped-list-detail/grouped-list-detail.component';
var GroupedSaleTaxListComponent = (function () {
    function GroupedSaleTaxListComponent(apiService, template) {
        this.apiService = apiService;
        this.template = template;
        this.list = [];
        this.currentPage = 1;
        this.checked = false;
        this.loading = false;
    }
    GroupedSaleTaxListComponent.prototype.ngOnInit = function () {
        this.pageChanged();
    };
    GroupedSaleTaxListComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.searchE(params);
    };
    GroupedSaleTaxListComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    GroupedSaleTaxListComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    GroupedSaleTaxListComponent.prototype.clearSearch = function () {
        this.startDate = null;
        this.endDate = null;
        this.inputText = null;
        if (this.currentPage === 1)
            this.searchE();
        else
            this.currentPage = 1;
    };
    GroupedSaleTaxListComponent.prototype.searchE = function (params) {
        var _this = this;
        var searchParams = {
            group_data_by_month: true,
            document_type: ['tax_invoice', 'receipt'],
            search_box: this.inputText,
            start_date: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
            end_date: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
        };
        this.loading = true;
        this.setModalSearchParams(searchParams);
        if (this.currentPage === 1) {
            this.apiService.postSearch(searchParams).subscribe(function (res) {
                _this.list = res.results;
                _this.totalItems = res.count;
                _this.loading = false;
            });
        }
        else {
            this.apiService.postSearch1(searchParams, params).subscribe(function (res) {
                _this.list = res.results;
                _this.totalItems = res.count;
                _this.loading = false;
            });
        }
    };
    GroupedSaleTaxListComponent.prototype.setModalSearchParams = function (searchParams) {
        searchParams = _.cloneDeep(searchParams);
        searchParams['group_data_by_month'] = false;
        this.detailModal.searchParams = searchParams;
    };
    GroupedSaleTaxListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(data);
    };
    GroupedSaleTaxListComponent.prototype.download = function (data, index) {
        var _this = this;
        data.pdfLoading = true;
        this.apiService.getSalesTaxReport({ 'month': data.month, 'year': data.year }).subscribe(function (obj) {
            var filename = 'documents' + moment().format('YYYY-MM-DD') + '.pdf';
            _this.apiService.createDownloadFile(obj, filename);
            data.pdfLoading = false;
        }, function (error) {
            data.pdfLoading = false;
        });
    };
    GroupedSaleTaxListComponent.prototype.downloadZip3MB = function (data, index) {
        var _this = this;
        data.xmlLoading = true;
        this.apiService.getZip3MB({ 'month': data.month, 'year': data.year }).subscribe(function (obj) {
            var filename = 'documents' + moment().format('YYYY-MM-DD') + '.zip';
            _this.apiService.createDownloadFile(obj, filename);
            data.xmlLoading = false;
        }, function (error) {
            data.xmlLoading = false;
        });
    };
    return GroupedSaleTaxListComponent;
}());
export { GroupedSaleTaxListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list/grouped-list.component.ts.pre-build-optimizer.js